import { render, staticRenderFns } from "./ProfissionalTabList.vue?vue&type=template&id=378ddfb3&scoped=true"
import script from "./ProfissionalTabList.vue?vue&type=script&lang=js"
export * from "./ProfissionalTabList.vue?vue&type=script&lang=js"
import style0 from "./ProfissionalTabList.vue?vue&type=style&index=0&id=378ddfb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ddfb3",
  null
  
)

export default component.exports